
export interface UIDropDownBlotter   {
  name: string;
  id: string;
  destType?: string[];
  orderType?: string[];
  trailingStopAvailable?: string[];
  permissions?: boolean[];
  citadel?: boolean[];
  virtu?: boolean[];
  value?: string;
}

export const orderTypes: UIDropDownBlotter[] = [
  {
    name: 'Market',
    id: 'MARKET',
    destType: ['BLOCKDESK', 'ARRIVAL', 'ORDERTYPEONLY', 'NONSELLALL'],
    trailingStopAvailable: ['TRUE', 'FALSE'],
    value: 'MARKET'
  },
  {
    name: 'Limit',
    id: 'LIMIT',
    destType: ['BLOCKDESK', 'ARRIVAL', 'NONSELLALL'],
    trailingStopAvailable: ['TRUE', 'FALSE'],
    value: 'LIMIT'
  },
  {
    name: 'Stop',
    id: 'STOP',
    destType: ['NONSELLALL'],
    trailingStopAvailable: ['TRUE', 'FALSE'],
    value: 'STOP'
  },
  {
    name: 'Stop Limit',
    id: 'STOPLIMIT',
    destType: ['NONSELLALL'],
    trailingStopAvailable: ['TRUE', 'FALSE'],
    value: 'STOPLIMIT'
  }/*,
  {
    name: 'Trailing Stop $',
    id: 'TRAILING_STOP_DOLLAR',
    destType: ['BLOCKDESK'],
    trailingStopAvailable: ['TRUE'],
    value: 'TRAILING_STOP_DOLLAR'
  },
  {
    name: 'Trailing Stop %',
    id: 'TRAILING_STOP_PRC',
    destType: ['BLOCKDESK'],
    trailingStopAvailable: ['TRUE'],
    value: 'TRAILING_STOP_PRC'
  }*/
];
export const expTypes: UIDropDownBlotter[] = [
  {
    name: 'Day',
    id: 'DAY',
    orderType: ['MARKET', 'STOP', 'STOPLIMIT', 'mBLOCKDESK', 'lBLOCKDESK', 'ISOPTION', 'LIMIT'], // added limit
    value: 'DAY'
  },
  {
    name: 'Day Ext',
    id: 'DAYEXT',
    orderType: ['LIMIT'],
    value: 'DAYEXT'
  },
  {
    name: 'Ext. AM',
    id: 'EXTAM',
    orderType: ['LIMIT'],
    value: 'EXTAM'
  },
  {
    name: 'Ext. PM',
    id: 'EXTPM',
    orderType: ['LIMIT'],
    value: 'EXTPM'
  },
  {
    name: 'GT6m',
    id: 'GT6M',
    orderType: ['STOP', 'STOPLIMIT', 'lBLOCKDESK', 'LIMIT'], // added limit
    value: 'GT6M'
  },
  {
    name: 'GTD',
    id: 'GTD',
    orderType: ['STOP', 'STOPLIMIT', 'lBLOCKDESK', 'ISOPTION', 'LIMIT'], // added limit
    value: 'GTD',
  },
  {
    name: 'GTD Ext',
    id: 'GTDEXT',
    orderType: ['LIMIT'],
    value: 'GTDEXT',
  },
  {
    name: 'MoC',
    id: 'Market On Close',
    orderType: ['MARKET'],
    value: 'Market On Close'
  }
];
export const priceTypes: UIDropDownBlotter[] = [
  {
    name: 'Price',
    id: 'None',
    value: 'None'
  },
  {
    name: 'Last Trade',
    id: 'LASTTRADE',
    value: 'LASTTRADE'
  },
  {
    name: 'Bid',
    id: 'BID',
    value: 'BID'
  },
  {
    name: 'Ask',
    id: 'ASK',
    value: 'ASK'
  },
  {
    name: 'Midpoint',
    id: 'MIDPOINT',
    value: 'MIDPOINT'
  },
];

export const optionOrderTypes: UIDropDownBlotter[] = [
  {
    "id": "EVEN_MONEY",
    "name": "Even Money",
    "value": "EVEN_MONEY"
  }, {
    "id": "NET_DEBIT",
    "name": "Debit",
    "value": "NET_DEBIT"
  }, {
    "id": "NET_CREDIT",
    "name": "Credit",
    "value": "NET_CREDIT"
  }
];
export const ordNotHeldFillPolicys: UIDropDownBlotter[] = [
  {
    "id": "Exchange",
    "name": "Per Exchange",
    "value": "Exchange"
  }
];
export const ordNotHeldIncludeExclude: UIDropDownBlotter[] = [
  {
    "id": "Include",
    "name": "Include",
    "value": "Include"
  }, {
    "id": "Exclude",
    "name": "Exclude",
    "value": "Exclude"
  }
];

export const ordNotHeldStyles: UIDropDownBlotter[] = [
  {
    "id": "PASSIVE",
    "name": "Passive",
    "value": "PASSIVE"
  //"selected": "selected"
  }, {
    "id": "NEUTRAL",
    "name": "Neutral",
    "value": "NEUTRAL"
  }, {
    "id": "AGGRESSIVE",
    "name": "Aggressive",
    "value": "AGGRESSIVE"
  }
];

export function getDestinations(pList: any): UIDropDownBlotter[] {
  return [
    {
      id: "AOM_PRINTER",
      name: "Block Desk",
      permissions: [pList["Block_Desk_Not_Held"]],
      value: "AOM_PRINTER",
    },
    {
      id: "VIRTU",
      name: "Virtu",
      permissions: [
        pList["Virtu_Opportunistic"] ||
        pList["Virtu_Oasis"] ||
        pList["Virtu_Target Close"] ||
        pList["Virtu_Catch"] ||
        pList["Virtu_VWAP"] ||
        pList["Virtu_TWAP"] ||
        pList["Virtu_Covert"] ||
        pList["Virtu_Fan"] ||
        pList["Virtu_Percent of Volume"]
      ],
      value: "VIRTU",
    },
    {
      id: "CITADEL",
      name: "Citadel",
      permissions: [
        pList["Citadel_Percent of Volume"] || 
        pList["Citadel_TWAP"] || 
        pList["Citadel_VWAP"]
      ],
      value: "CITADEL",
    },
  ];
}

export function getAlgorithms(pList: any): UIDropDownBlotter[] {
  return [
    {
      id: "CITADEL_PERCENTAGE_OF_VOLUME",
      name: "Percent of Volume",
      permissions: [pList["Citadel_Percent of Volume"]],
      virtu: [false],
      citadel: [true],
      value: "PERCENTAGE_OF_VOLUME"
    },
    {
      id: "CITADEL_TWAP",
      name: "TWAP",
      permissions: [pList["Citadel_TWAP"]],
      virtu: [false],
      citadel: [true],
      value: "TWAP"
    },
    {
      id: "CITADEL_VWAP",
      name: "VWAP",
      permissions: [pList["Citadel_VWAP"]],
      virtu: [false],
      citadel: [true],
      value: "VWAP"
    },
    /******************************************/
    {
      id: "VIRTU_OPPORTUNISTIC",
      name: "Opportunistic",
      permissions: [pList["Virtu_Opportunistic"]],
      virtu: [true],
      citadel: [false],
      value: "OPPORTUNISTIC"
    },
    {
      id: "VIRTU_OASIS",
      name: "Oasis",
      permissions: [pList["Virtu_Oasis"]],
      virtu: [true],
      citadel: [false],
      value: "OASIS"
    },
    {
      id: "VIRTU_TARGET_CLOSE",
      name: "Target Close",
      permissions: [pList["Virtu_Target Close"]],
      virtu: [true],
      citadel: [false],
      value: "TARGET_CLOSE"
    },
    {
      id: "VIRTU_CATCH",
      name: "Catch",
      permissions: [pList["Virtu_Catch"]],
      virtu: [true],
      citadel: [false],
      value: "CATCH",
    },
    {
      id: "VIRTU_VWAP",
      name: "VWAP",
      permissions: [pList["Virtu_VWAP"]],
      virtu: [true],
      citadel: [false],
      value: "VWAP"
    },
    {
      id: "VIRTU_TWAP",
      name: "TWAP",
      permissions: [pList["Virtu_TWAP"]],
      virtu: [true],
      citadel: [false],
      value: "TWAP"
    },
    {
      id: "VIRTU_COVERT",
      name: "Covert",
      permissions: [pList["Virtu_Covert"]],
      virtu: [true],
      citadel: [false],
      value: "COVERT"
    },
    {
      id: "VIRTU_FAN",
      name: "Fan",
      permissions: [pList["Virtu_Fan"]],
      virtu: [true],
      citadel: [false],
      value: "FAN"
    },
    {
      id: "VIRTU_PERCENTAGE_OF_VOLUME",
      name: "Percent of Volume",
      permissions: [pList["Virtu_Percent of Volume"]],
      virtu: [true],
      citadel: [false],
      value: "PERCENTAGE_OF_VOLUME"
    }
  ];
}

export interface iLayoutFieldsShowHide{
  limitInstructionTextVisible:boolean;
  destinationInstructionText:boolean;
  destiDepField:boolean;
  layExpirationtype:boolean;
  layexpirationdate:boolean;
  layNotHeld:boolean;
  layDestination:boolean;
  algorithmDepFieldsLayDisplay:boolean;
  fillReportingLay:boolean;
  startTimeLay:boolean;
  endTimeLay:boolean;
  participationLay:boolean;
  incExclLay:boolean;
  maxVolumeLay:boolean;
  maxVolumeLabel: string;
  displaySizeLay:boolean;
  styleLay:boolean;
  iWPriceLayDisplay:boolean;
  blockDeskDepFieldsLay:boolean;
  auctionOnlyLay: boolean;
}
